/* Header menus hover */
$(document).ready(function () {
  $(this).find("details").attr("open", "open");
  $(".menu__item").hover(
    function () {
      $(this).find(".menu-dropdown").addClass("cs-menu-active");
    },
    function () {
      $(this).find(".menu-dropdown").removeClass("cs-menu-active");
    }
  );
});
$(document).ready(function () {
  $(".slick-next").on("click", function () {
    $(".slick-prev").addClass("active");
  });
});

$(".home-page-slider").slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".linktree_slide").slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".linktree_slide_dasktop").slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2500,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".recom-slider-product").slick({
  infinite: true,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
$(".et-single-google-review").slick({
  infinite: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".gallery-wrap").slick({
  infinite: true,
  autoplay: false,
  autoplaySpeed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerPadding: "180px",
  responsive: [
    {
      breakpoint: 778,
      settings: {
        centerPadding: "50px",
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
  ],
});

/* Homepage product carousel */
$(".feature-coll-carousel-tab").on(
  "init afterChange",
  function (event, slick, currentSlide) {
    if (currentSlide === slick.slideCount - 1) {
      $(".slick-next").hide(); // Hide the "Next" button on the last tab
    } else {
      $(".slick-next").show(); // Show the "Next" button for other tabs
    }
  }
);

$(".feature-coll-carousel-tab").slick({
  infinite: false,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 1000,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

/* Homepage reviews carousel */
$(".review-slide-home").slick({
  infinite: true,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
$(".pose-nav-slide").slick({
  infinite: true,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
});

$(document).ready(function () {
  var slider = $(".tab-content-slide");
  var tabNavLinks = $(".pose-tab-nav li a");
  slider.slick({
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  tabNavLinks.on("click", function (e) {
    e.preventDefault();
    var targetTab = $(this).attr("href");
    var slideIndex = $(targetTab).index();
    slider.slick("slickGoTo", slideIndex, true);
    tabNavLinks.closest("li").removeClass("active");
    $(this).closest("li").addClass("active");
  });
  slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    tabNavLinks.closest("li").removeClass("active");
    tabNavLinks.eq(nextSlide).closest("li").addClass("active");
  });
  tabNavLinks.first().closest("li").addClass("active");
});
// $(document).ready(function () {
//   var tabNavLinks = $(".pose-tab-nav li a");
//   var tabContentSlide = $(".tab-content-slide");

//   // Initialize Slick Slider with custom settings
//   tabContentSlide.slick({
//     infinite: false,
//     autoplay: true,
//     autoplaySpeed: 1000,
//     arrows: false,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     adaptiveHeight: true,
//     speed: 500,
//   });

//   tabNavLinks.on("click", function (e) {
//     e.preventDefault();
//     var targetTab = $(this).attr("href");
//     var targetTabIndex = $(targetTab).index();
//     tabContentSlide.slick("slickGoTo", targetTabIndex, false);
//     tabNavLinks.closest("li").removeClass("active");
//     $(this).closest("li").addClass("active");
//   });
//   tabContentSlide.on(
//     "beforeChange",
//     function (event, slick, currentSlide, nextSlide) {
//       tabNavLinks.closest("li").removeClass("active");
//       tabNavLinks.eq(nextSlide).closest("li").addClass("active");
//     }
//   );
//   tabNavLinks.first().closest("li").addClass("active");
// });

// Get the current URL
var currentUrl = window.location.pathname;
// Loop through the menu links and add active class to the matching link
document.querySelectorAll(".collection-link").forEach(function (link) {
  var linkUrl = link.getAttribute("href");
  if (linkUrl === currentUrl) {
    link.classList.add("active");
  }
});

mobileOnlySlider(".category-item-list", true, false, 767);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: $arrows,
    slidesToShow: 3,
    swipeToSlide: true,
    variableWidth: true,
    infinite: true,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}
mobileOnlySlider(".et-product-page-client-logo", true, false, 767);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: $arrows,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    swipeToSlide: true,
    variableWidth: true,
    infinite: true,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}
// Slider ko refresh kare
$(document).ready(function () {
  $(".full-tab-section .image-tab-looking:first-child").addClass("active");
  $(".full-tab-section .image-tab-looking").click(function () {
    var $topSection = $(this).closest(".full-tab-section");
    $topSection.find(".image-tab-looking").removeClass("active");
    $(this).addClass("active");
    var imageUrl = $(this).data("img");
    $topSection
      .find(".full-tab-section-inner .full-tab-half-right img")
      .attr("src", imageUrl);
  });
  $(".full-tab-content-right").each(function () {
    var $section = $(this);
    if (!$section.find(".full-tab-content-div").hasClass("main")) {
      $section.find(".full-tab-content-div").eq(0).addClass("main");
      var firstImgUrl = $section.find(".image-tab-looking").eq(0).data("img");
      $section.find(".displayed-image").attr("src", firstImgUrl);
    }
    $section.find(".image-tab-looking").click(function () {
      $section.find(".full-tab-content-div").removeClass("main");
      $(this).find(".full-tab-content-div").addClass("main");
      var imgUrl = $(this).data("img");
      $section.find(".displayed-image").attr("src", imgUrl);
    });
  });
});

/* Show more show less homepage */
$(document).ready(function () {
  // Initially, hide all feature box texts and "View Less" buttons
  $(".feature-box-text").hide();
  $(".show-less").hide();

  // Click event handler for "View More"
  $(".feature-content").on("click", ".show-more", function () {
    var $parentBox = $(this).closest(".feature-box-single");
    $parentBox.find(".feature-box-text").show(300);
    $parentBox.find(".show-less").show();
    $(this).hide();
  });

  // Click event handler for "View Less"
  $(".feature-content").on("click", ".show-less", function () {
    var $parentBox = $(this).closest(".feature-box-single");
    $parentBox.find(".feature-box-text").hide(150);
    $parentBox.find(".show-more").show();
    $(this).hide();
  });
});

/* Header on scrool class add */
$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 110) {
      $(".cs-main-header").addClass("fixed animated slideInUp");
    } else {
      $(".cs-main-header").removeClass("fixed animated slideInUp");
    }
  });
});

/* Accordion */
$(document).ready(function () {
  $(".course-accordion").click(function () {
    if ($(this).hasClass("click-active")) {
      $(this).removeClass("click-active");
      $(this).next(".course-panel").removeClass("click-active");
    } else {
      $(".course-accordion").removeClass("click-active");
      $(".course-panel").removeClass("click-active");
      $(this).addClass("click-active");
      $(this).next(".course-panel").addClass("click-active");
    }
  });
});

/* Faq accordion */
$(".faq-accordion").click(function () {
  var isCurrentlyActive = $(this).hasClass("faq-active");
  $(".faq-accordion").removeClass("faq-active");
  $(".faq-panel").removeClass("active");
  if (!isCurrentlyActive) {
    $(this).addClass("faq-active");
    $(this).siblings(".faq-panel").addClass("active");
  }
});

/* Product tab */
$(document).ready(function () {
  $(".product-tab-link:first").addClass("active");
  $(".product-tab-content:first").addClass("active");
  $(".product-tab-link").on("click", function (event) {
    event.preventDefault();
    const target = $(this).attr("href");
    $(".product-tab-link").removeClass("active");
    $(".product-tab-content").removeClass("active");
    $(this).addClass("active");
    $(target).addClass("active");
  });
});

/* Grid and list view */
$(document).ready(function () {
  $(".view-button").on("click", function (event) {
    event.preventDefault(); // Prevent the default behavior (page reload)

    $(".view-button").removeClass("active");
    $(this).addClass("active");

    if ($(this).attr("id") === "grid-view-button") {
      $(".tab-content").removeClass("list-view").addClass("grid-view");
    } else {
      $(".tab-content").removeClass("grid-view").addClass("list-view");
    }
  });
});

/* Tab active class */
$(document).ready(function () {
  $(".job-tabs .tab").on("click", function (e) {
    e.preventDefault();
    $(".job-tabs .tab").removeClass("is-active");
    $(this).addClass("is-active");
  });
});
$(document).ready(function () {
  // Add a click event handler to the tab titles
  $(".tab-title").click(function (e) {
    e.preventDefault();

    // Remove the 'active' class from all tab contents and 'has-jsContent' class
    $(".tab-content").removeClass("active has-jsContent");

    // Get the href attribute of the clicked tab title
    var targetTab = $(this).attr("href");

    // Add the 'active' class to the corresponding tab content and 'has-jsContent'
    $(targetTab).addClass("active has-jsContent");
  });
});

/* Product page button click popup modal */
$(".product-modal-toggle").on("click", function (e) {
  e.preventDefault();
  $(".product-modal").toggleClass("is-visible");
});

/* Product page button click popup modal */
$(".mobile-toggle-open-cont").on("click", function (e) {
  e.preventDefault();
  $(".ingredient-cont-item").removeClass("active");
  $(this).closest(".ingredient-cont-item").addClass("active");
  $(this).hide();
  $(this).siblings(".mobile-toggle-close-cont").show();
});

$(".mobile-toggle-close-cont").on("click", function (e) {
  e.preventDefault();
  $(".ingredient-cont-item").removeClass("active");
  $(this).hide();
  $(this).siblings(".mobile-toggle-open-cont").show();
});

/* Product page button click  */
$(".npv2-cs-steps").on("click", function (e) {
  e.preventDefault();
  $(".htu-step-wrap").removeClass("active");
  $("a.npv2-step-link").removeClass("active");
  var this_href = $(this).attr("href");
  var this_has_href = "#" + this_href;
  $(".htu-step-section").find(this_href).addClass("active");
  $(this).addClass("active");
});

$(".npv2-step-link-bundle").on("click", function (e) {
  e.preventDefault();
  var $this = $(this);
  var $section = $this.closest(".et-bundle-section-pv2");
  $section.find(".et-bundle-step").removeClass("active");
  $section.find("a.npv2-step-link-bundle").removeClass("active");
  var targetStep = $this.attr("href");
  $section.find(targetStep).addClass("active");
  $this.addClass("active");
});

// crew on click hide show
$(document).ready(function () {
  var itemsToShow = 6; // Change this to the number of items to show initially
  var gallery = $(".crews-row-main");
  var galleryItems = $(".crew-item");
  var moreButton = $(".more-button");
  var lessButton = $(".less-button");
  var currentIndex = 0;

  function showItems(startIndex, endIndex) {
    galleryItems.slice(startIndex, endIndex).fadeIn(300);
  }

  function hideItems(startIndex, endIndex) {
    galleryItems.slice(startIndex, endIndex).fadeOut(300);
  }

  showItems(currentIndex, currentIndex + itemsToShow);
  currentIndex += itemsToShow;

  moreButton.click(function () {
    if (currentIndex < galleryItems.length) {
      showItems(currentIndex, currentIndex + itemsToShow);
      currentIndex += itemsToShow;
    }

    if (currentIndex >= galleryItems.length) {
      moreButton.hide();
      lessButton.show();
    }
  });

  lessButton.click(function () {
    if (currentIndex > itemsToShow) {
      currentIndex -= itemsToShow;
      hideItems(currentIndex, currentIndex + itemsToShow);
    }

    if (currentIndex <= itemsToShow) {
      lessButton.hide();
      moreButton.show();
    }
  });
});

//product stickey header
$(document).ready(function () {
  var stickyTopProduct = $(".sticky-top-product");
  $(window).scroll(function () {
    var scrollPosition = $(window).scrollTop();
    var scrollTriggerPosition = 100;
    if (scrollPosition >= scrollTriggerPosition) {
      stickyTopProduct.addClass(
        "header-wrap cs-main-header poseidn-header-wrap fixed animated slideInUp scroll-up"
      );
    } else {
      stickyTopProduct.removeClass(
        "header-wrap cs-main-header poseidn-header-wrap fixed animated slideInUp scroll-up"
      );
    }
  });
});

//poseidn header
let lastScrollTop = 0;
$(window).scroll(function () {
  const st = $(this).scrollTop();
  const headerWrap = $(".poseidn-header-wrap");
  if (st > lastScrollTop) {
    headerWrap.removeClass("scroll-up");
  } else {
    headerWrap.addClass("scroll-up");
  }
  if (st === 0) {
    headerWrap.removeClass("scroll-up");
  }
  lastScrollTop = st;
});

//mobile active class
// $(document).ready(function () {
//   $(".cs-menu-link").click(function (e) {
//     var submenu = $(this).find(".cs-menu");
//     if (submenu.length > 0) {
//       e.preventDefault();
//       $(this).toggleClass("active");
//       submenu.toggleClass("cs-active-main");
//     }
//   });
// });
$(document).ready(function () {
  $(".cs-main-collection-info").click(function () {
    $("ul.cs-menu.dropdown-child").toggleClass("cs-active-main");
  });
});
//collection pagination
$(function () {
  $(".js-seq-animate").slice(0, 12).show();

  $("#loadMore").on("click", function (e) {
    e.preventDefault();
    var hiddenElements = $(".js-seq-animate:hidden");
    var numToSlice = Math.min(hiddenElements.length, 12);
    hiddenElements.slice(0, numToSlice).slideDown();

    if (hiddenElements.length <= numToSlice) {
      $("#loadMore").hide();
    }
  });
});
$(function () {
  $(".list-product-item").slice(0, 12).show();

  $("#loadMore").on("click", function (e) {
    e.preventDefault();
    var hiddenElements = $(".list-product-item:hidden");
    var numToSlice = Math.min(hiddenElements.length, 12);
    hiddenElements.slice(0, numToSlice).slideDown();

    if (hiddenElements.length <= numToSlice) {
      $("#loadMore").hide();
    }
  });
});

//about us page scroller
// $(window)
//   .scroll(function () {
//     var $window = $(window),
//       $body = $("body"),
//       $panel = $(".cs-problem-statement");
//     var threshold = $window.height() / 2;
//     var scroll = $window.scrollTop() + $window.height() / 2;
//     $(".cs-problem-statement").removeClass("active");
//     $panel.each(function () {
//       var $this = $(this);
//       var elementTop = $this.position().top + $this.height() / 2;
//       if (
//         elementTop - threshold <= scroll &&
//         elementTop + threshold >= scroll
//       ) {
//         $this.addClass("active");
//       }
//     });
//   })
//   .scroll();

$(document).ready(function () {
  var defaultImageSrc = $(".cs-statement-inner img").attr("src"); // Store the default image source

  $(window)
    .scroll(function () {
      var $window = $(window);
      var scroll =
        $window.scrollTop() + ($window.height() - $window.height()) + 150;
      var matchFound = false;

      $(".cs-problem-statement").each(function () {
        var $statement = $(this);
        var statementTop = $statement.offset().top;
        var statementImage = $statement
          .find(".cs-statement-body")
          .data("image");

        if (
          scroll >= statementTop &&
          scroll <= statementTop + $statement.height()
        ) {
          $(".cs-statement-inner img").attr("src", statementImage);
          matchFound = true;
          return false;
        }
      });

      if (!matchFound) {
        // If no matching section is found, reset the image to the default
        $(".cs-statement-inner img").attr("src", defaultImageSrc);
      }

      if (matchFound) {
        $(".cs-statement-inner").addClass("scroll-active");
      } else {
        $(".cs-statement-inner").removeClass("scroll-active");
      }
    })
    .scroll();
});

//search bar enter
$(document).ready(function () {
  $(".js-predictive-search-form").on("submit", function (event) {
    event.preventDefault();
    var searchTerm = $(this).find(".js-predictive-search-input").val();
  });
});

//work tab
$(document).ready(function () {
  $(".main-category-sec").click(function () {
    $(".cs-inner-tabs-sec").removeClass("active-tab");
    var index = $(this).index();
    $(".cs-inner-tabs-sec:eq(" + index + ")").addClass("active-tab");
    $(".work-image-sec").addClass("active-work-sec");
  });
  $(".cs-inner-tabs-sec:first").addClass("active-tab");
});

/* Add to cart click smooth scroll on header */
$('form[data-type="add-to-cart-form"]').on("submit", function (event) {
  event.preventDefault(); // prevent default form submission
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: $(this).serialize(),
    dataType: "json",
    success: function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
      console.log("success");
    },
    error: function () {
      console.log("Error");
    },
  });
});

/* Smooth scroll on anchor click */
$(document).ready(function () {
  $('a[href="#how-it-work"]').click(function (e) {
    e.preventDefault();
    var this_data_id = $(this).attr("data-id");
    $(
      '.htu-step-action-style-2 .npv2-step-link[href="#' + this_data_id + '"]'
    ).trigger("click");
    var target = this.hash;
    $target = $(target);

    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - 100,
        },
        900,
        "swing",
        function () {
          window.location.hash = target;
        }
      );
  });
});

// $(".et-bundle-easy-step").on("click", ".npv2-step-link", function (e) {
//   e.preventDefault();
//   var $this = $(this);
//   var $section = $this.closest(".et-bundle-section-pv2");
//   $section.find(".et-bundle-step").removeClass("active");
//   $section.find("a.npv2-step-link").removeClass("active");
//   var targetStep = $this.attr("href");
//   $section.find(targetStep).addClass("active");
//   $this.addClass("active");
// });




//product info
$(document).ready(function () {
  $(".et-bundle-product-wrap-pv2 p").hide();
  $(".main-content-show").on("click", function (e) {
    e.preventDefault();
    $(".et-bundle-product-wrap-pv2 p").show();
      $(".main-content-show").hide();
  });
});


mobileOnlySlider(".cs-mobile-slider-1", true, 767);

function mobileOnlySlider($slidername, $dots, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    swipeToSlide: true,
    infinite: true,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}

//currency selector
$('.shopify-currency-form select').on('change', function() {
  $(this) .parents('form').submit();
});



mobileOnlySlider(".et-product-page-client-logo", true, 767);

function mobileOnlySlider($slidername, $dots, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    swipeToSlide: true,
    infinite: true,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}



mobileOnlySlider(".step-1", true, 767);

function mobileOnlySlider($slidername, $dots, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    swipeToSlide: true,
    infinite: true,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}


mobileOnlySlider(".step-2", true, 767);

function mobileOnlySlider($slidername, $dots, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    swipeToSlide: true,
    infinite: true,
    responsive: [
      {
        breakpoint: $breakpoint,
        settings: "unslick",
      },
    ],
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
}